/* eslint-disable @typescript-eslint/ban-ts-comment */
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { getSingleProcessTemplate } from 'features/processTemplates/processTemplatesSlice'
import React from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Flex, ItemsGrid, ThinSeparator } from 'styling/GlobalStyles'
import { IProcessTemplatesSingleResponse } from 'types/api/processTemplatesApi.interface'
import { IPhaseState, IProcessBindingConfigState } from 'types/operationPlans.interface'

export const ProcessTemplateType = ({ addingPhase, setAddingPhase }: { addingPhase: IPhaseState<IProcessBindingConfigState>, setAddingPhase: React.Dispatch<React.SetStateAction<IPhaseState<IProcessBindingConfigState>>> }) => {
    const dispatch = useDispatch<AppDispatch>()
    const parse = (data: any) => {
        return data ? data.data.map((item: any) => ({ label: item.name, value: item.id })) : []
    }

    const handleProcessSelect = async (value: ISelectValue) => {
        const resp = await dispatch(getSingleProcessTemplate(value.value.toString()))
        if (resp.meta.requestStatus === 'fulfilled') {
            // @ts-ignore 
            setAddingPhase(prev => ({
                ...prev, processTemplate: { label: value.label, value: value.value }, bindingConfig: {
                    startDate: null,
                    department: null,
                    componentsData: (resp.payload as IProcessTemplatesSingleResponse).components.map((component) => ({ processTemplateComponent: { label: component.name, value: component.id }, value: null }))
                }
            }))
        }

    }

    const handleComponentValue = (e: React.ChangeEvent<HTMLInputElement>, componentId: number | string) => {
        // @ts-ignore
        setAddingPhase(prev => ({
            ...prev, bindingConfig: {
                ...prev.bindingConfig, componentsData: prev.bindingConfig.componentsData.map(c => c.processTemplateComponent?.value === componentId ? { ...c, value: e.target.value } : c)
            }
        }))
    }

    return <>
        <Flex column gap='1rem' >
            <HonestSelectAsyncInput
                keyProp={2}
                defaultValue={addingPhase.processTemplate?.label}
                link='process/template/company'
                labelText='Task Process Template'
                onChange={handleProcessSelect}
                name='processTemplate'
                placeholder='Search Process Templates'
                parserFunction={parse}
                required
                invalid={!addingPhase.processTemplate?.value}
            />
            {addingPhase.processTemplate?.value && <>
                <Flex gap='1rem' >
                    <CalendarInput
                        labelText='Start Date'
                        name='startDate'
                        onChange={date => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, startDate: date } }))}
                        width='100%'
                    />
                </Flex>
                <HonestSelectAsyncInput
                    nomarg
                    link='locations'
                    placeholder='Search locations'
                    name='fromLocation'
                    labelText='From Location'
                    defaultValue={(addingPhase as IPhaseState<IProcessBindingConfigState>)?.bindingConfig?.location?.label}
                    onChange={value => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, location: value } }))}
                    parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                    required
                    invalid={!addingPhase.bindingConfig?.location?.value}
                />
                <HonestSelectAsyncInput
                    link='departments'
                    placeholder='Search department'
                    name='department'
                    labelText='Department'
                    defaultValue={(addingPhase as IPhaseState<IProcessBindingConfigState>)?.bindingConfig?.department?.label}
                    onChange={value => setAddingPhase(prev => ({ ...prev, bindingConfig: { ...prev.bindingConfig, department: value } }))}
                    parserFunction={(data: any) =>
                        data.data.map((i: any) => ({ label: i.name, value: i.id }))
                    }
                />
                <ThinSeparator />
                <ItemsGrid columns={2} >
                    {(addingPhase as IPhaseState<IProcessBindingConfigState>)?.bindingConfig?.componentsData?.map(c =>
                        <Input value={c.value ?? ''} key={c.processTemplateComponent?.value} width='100%' placeholder='Enter value' labelText={c.processTemplateComponent?.label + ' value'} name='value' onChange={e => handleComponentValue(e, c.processTemplateComponent?.value)} type='number' />
                    )}
                </ItemsGrid>
            </>}
        </Flex>

    </>
}